export default {
  SUCCESS: {
    text: 'Połączono',
    color: 'success',
  },
  NOT_LINKED: {
    text: 'Niepołączono',
    color: 'warning',
  },
  ERROR: {
    text: 'Błąd połączenia',
    color: 'danger',
  },
  LINKED: 'linked',
  OPERATION_TYPES: {
    'inbound': 'Przychód',
    'outbound': 'Rozchód',
  },
  PAYMENT_TYPES: {
    TRANSFER: 'transfer',
    CASH: 'cash',
  },
  OPERATION_TYPES_COLORS: {
    'inbound': '#00ac8b',
    'outbound': '#FF9F43',
  },
  OPERATION_TYPE_INBOUND: 'inbound',
  OPERATION_TYPE_OUTBOUND: 'outbound',
  SETTLEMENT_STATUSES: {
    PENDING: {
      label: 'Nie rozliczono',
      value: 'pending',
      color: '#f95448',
    },
    SETTLED: {
      label: 'Rozliczono',
      value: 'settled',
      color: '#00ac8b',
    },
    PARTIALLY_SETTLED: {
      label: 'Częściowo',
      value: 'partially_settled',
      color: '#f7b731',
    },
    MANUALLY_SETTLED: {
      label: 'Ręcznie rozliczono',
      value: 'manually_settled',
      color: '#6252dd',
    },
    PENDING_TO_MANUAL_MATCH: {
      label: 'Brak dopasowania',
      value: 'pending_to_manual_match',
      color: '#f95448',
    },
    DEFAULT: {
      label: 'Brak danych',
      value: null,
      color: '#835200',
    },
  },
  ACCOUNT_LINK_TYPES: {
    PERSONAL: 'personal',
    COMPANY: 'company'
  },
  BANK_IDS: {
    PKO: 'pko',
  }
};
